import { TForumMessage } from "../../types"
import './forum.scss'
import { ForumMessage } from "./ForumMessage"


type ForumMessagesProps = {
    messages: TForumMessage[] | undefined
}


export const ForumMessages = ({ messages }: ForumMessagesProps) => {
    return (
        <div className='forum_messages'>
            {
                messages?.map(m => <ForumMessage message={m} />)
            }
        </div>
    )
}